window.addEventListener('load', () => {
	const bg = document.querySelector('.bg-boxes');
	if (!bg)
		return;

	for (let i = 0; i < 15; i++) {
		makeNewParticle(bg);
	}
});

function makeNewParticle(bg, prev) {
	const elem = prev ? prev : document.createElement('DIV');
	const style = elem.style;

	const isHuge = Math.random() < 0.07;
	const size = Math.floor(Math.random() * 130) + (isHuge ? 400 : 20);
	const duration = Math.floor((Math.random() * 5 + 3) * 1000) / 1000;
	const left = Math.random() < 0.5;

	style.width = style.height = size + 'px';
	style.top = Math.floor(Math.random() * 100) + '%';
	style.left = Math.floor(Math.random() * 100) + '%';
	style.animationDuration = duration + 's';
	style.animationName = left ? 'spin-left' : 'spin-right';
	style.setProperty('--movex', (left ? -1 : 1) * Math.max(Math.ceil(10000 / size * (Math.random() / 2 + 0.75)), 75) + 'px');
	style.setProperty('--fader', Math.round(Math.random() * 60 + 60) + 'deg');

	elem.classList[isHuge ? 'add' : 'remove']('black');

	if (!prev) {
		elem.addEventListener('animationend', () => makeNewParticle(bg, elem));
		bg.appendChild(elem);
	} else {
		bg.replaceChild(elem, elem);
	}
}
